import { getServiceUrl, httpPost } from '../services/api';

const getUrl = (url) => getServiceUrl('pep', url);

export async function savePoliticallyExposedPersonMatch(data: { politicallyExposedPersonText?: string }) {
    return httpPost<void>(getUrl('match'), data);
}
